const stages = [
  { n: '01', title: 'Discover', copy: 'We listen first — to your ambitions, your challenges, and the context behind them — so we understand what genuinely matters before anything else.' },
  { n: '02', title: 'Connect', copy: 'We bring perspective, expertise, and the right people into the conversation, drawing on relationships built carefully over many years.' },
  { n: '03', title: 'Grow', copy: 'We stay alongside you as decisions take shape, supporting the people and teams that carry your organisation forward.' },
];

const band = ['PEOPLE FIRST', 'POSSIBILITY FOLLOWS', 'PEOPLE FIRST', 'POSSIBILITY FOLLOWS', 'PEOPLE FIRST', 'POSSIBILITY FOLLOWS'];

export default function DarkChapter() {
  return (
    <div data-theme-chapter="dark" data-chapter-dark>
      {/* 04 People First */}
      <section className="pt-16 md:pt-24">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px] bg-background-100 text-foreground-950 p-4 md:p-6 lg:p-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              <div className="flex flex-col justify-between p-2 md:p-4 lg:py-6">
                <div>
                  <p className="font-label text-[12px] md:text-[13px] tracking-[0.2em] text-foreground-600">PEOPLE FIRST</p>
                  <h2 className="mt-5 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em]">
                    Behind every business decision, there are people.
                  </h2>
                  <div className="mt-7 space-y-4 text-[16px] leading-[1.6] text-foreground-800 max-w-[480px]">
                    <p>Every hire, restructure, and leadership change is ultimately about individuals.</p>
                    <p>
                      Their ambitions, their potential, and the environments where they do their best work shape what an organisation can become.
                    </p>
                    <p>
                      We take the time to understand both sides of every decision — the business and the people within it — so the outcome holds up long after the conversation ends.
                    </p>
                    <p>The approach adapts. The care does not.</p>
                  </div>
                </div>
                <p className="mt-10 font-label text-[13px] text-foreground-600">Independent HR &amp; Talent Advisory</p>
              </div>
              <div
                data-motion="window-parallax"
                className="cut-tl w-full h-[380px] sm:h-[480px] lg:h-[620px] bg-background-200"
                style={{ ['--cut' as string]: '120px' }}
              >
                <div data-parallax-inner className="w-full h-full">
                  <img
                    src="https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_home-people-first.webp"
                    alt="An HR advisor in a focused conversation with a company founder"
                    title="People first advisory conversation — Morrow People"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          data-motion="marquee"
          className="mt-16 md:mt-20 border-y chapter-border py-5 md:py-6"
          aria-label="People first — possibility follows"
        >
          <div data-marquee-track className="inline-flex" aria-hidden="true">
            {[...band, ...band].map((word, idx) => (
              <span
                key={`${word}-${idx}`}
                className="font-display font-light text-[clamp(1.6rem,3vw,2.5rem)] leading-none tracking-[-0.01em] chapter-fg pr-6"
              >
                {word} <span className="text-accent-500 pl-6">—</span>
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* 05 How We Work */}
      <section className="pt-20 md:pt-28 pb-16 md:pb-20">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px]">
            <p className="font-label text-[12px] md:text-[13px] tracking-[0.2em] chapter-muted">HOW WE WORK</p>
            <h2 className="mt-5 max-w-[640px] font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em] chapter-fg">
              Good partnerships begin with understanding.
            </h2>
            <ol className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-10">
              {stages.map((s) => (
                <li key={s.n} className="border-t chapter-border pt-5">
                  <span className="block font-label text-[13px] leading-none tracking-[0.12em] text-accent-400">{s.n}</span>
                  <h3 className="mt-8 font-display font-normal text-[28px] md:text-[32px] leading-[1.1] chapter-fg">{s.title}</h3>
                  <p className="mt-4 text-[15px] md:text-[16px] leading-[1.65] chapter-muted max-w-[340px]">{s.copy}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
}